(function () {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-review-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    event.preventDefault();
    // Avoid a second scroll from the app's delegated badge handler.
    event.stopPropagation();
    widget.focus({ preventScroll: true });
    widget.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }, true);

  function formatMoney(cents) {
    if (window.theme?.formatMoney) return window.theme.formatMoney(cents);
    return `${new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((cents || 0) / 100)}€`;
  }

  function initGallery(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.bound === 'true') return;
      gallery.dataset.bound = 'true';
      const slides = [...gallery.querySelectorAll('.product-gallery__slide')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
      if (slides.length === 0) return;
      if (slides.length === 1) {
        gallery.querySelectorAll('[data-gallery-prev], [data-gallery-next], [data-gallery-dot], [data-gallery-thumb]').forEach((control) => {
          control.hidden = true;
        });
      }
      let index = 0;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        thumbs.forEach((thumb, i) => {
          const isActive = i === index;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb || 0)));
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => show(Number(dot.dataset.galleryDot || 0)));
      });
      gallery.querySelectorAll('[data-gallery-prev]').forEach((button) => {
        button.addEventListener('click', () => show(index - 1));
      });
      gallery.querySelectorAll('[data-gallery-next]').forEach((button) => {
        button.addEventListener('click', () => show(index + 1));
      });
    });
  }

  function initVariants(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.variantsBound === 'true') return;
      section.dataset.variantsBound = 'true';
      const json = section.querySelector('[data-variants-json]');
      if (!json) return;
      let variants = [];
      try {
        variants = JSON.parse(json.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(variants) || variants.length === 0) return;
      const inputs = [...section.querySelectorAll('[data-variant-radios] input')];
      const variantInput = section.querySelector('[data-variant-id]');
      const currentPrices = [...section.querySelectorAll('[data-price-current]')];
      const comparePrices = [...section.querySelectorAll('[data-price-compare]')];
      const button = section.querySelector('[data-add-to-cart]');
      const buttonText = section.querySelector('[data-add-to-cart-text]');
      const sellingPlanInputs = [...section.querySelectorAll('input[name="selling_plan"]')];

      function update() {
        const selected = inputs
          .filter((input) => input.checked)
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((input) => input.value);

        inputs.forEach((input) => {
          const optionIndex = Number(input.dataset.optionPosition) - 1;
          const canSelect = variants.some((candidate) => (
            candidate.available &&
            candidate.options[optionIndex] === input.value &&
            candidate.options.slice(0, optionIndex).every((option, index) => option === selected[index])
          ));
          const isUnavailable = !canSelect;

          input.closest('.variant-radios__pill')?.classList.toggle('is-unavailable', isUnavailable);
        });

        section.querySelectorAll('.variant-radios__pill').forEach((pill) => {
          pill.classList.toggle('is-selected', pill.querySelector('input')?.checked);
        });

        const variant = inputs.length === 0
          ? variants[0]
          : variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
        if (!variant) {
          if (variantInput) {
            variantInput.value = '';
            variantInput.disabled = true;
          }
          if (button) button.disabled = true;
          if (buttonText) buttonText.textContent = window.theme.strings.unavailable;
          return;
        }

        if (variantInput) {
          variantInput.disabled = false;
          variantInput.value = variant.id;
        }
        currentPrices.forEach((currentPrice) => {
          currentPrice.textContent = formatMoney(variant.price);
        });
        // PayPal observes this attribute and refreshes its message automatically.
        section.querySelectorAll('[data-pp-message]').forEach((message) => {
          message.setAttribute('data-pp-amount', (variant.price / 100).toFixed(2));
        });
        comparePrices.forEach((comparePrice) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePrice.textContent = formatMoney(variant.compare_at_price);
            comparePrice.hidden = false;
          } else {
            comparePrice.hidden = true;
          }
        });
        if (button) button.disabled = !variant.available;
        if (buttonText) buttonText.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        if (sellingPlanInputs.length > 0) {
          sellingPlanInputs.forEach((input) => {
            input.checked = input.value === '';
          });
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        if (variant.featured_media) {
          const thumb = section.querySelector(`[data-media-id="${variant.featured_media.id}"][data-gallery-thumb]`);
          thumb?.click();
        }

        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { variant }
        }));
      }

      inputs.forEach((input) => input.addEventListener('change', update));
      update();
    });
  }

  function initRelatedPager(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-related-pager]').forEach((pager) => {
      if (pager.dataset.bound === 'true') return;
      pager.dataset.bound = 'true';

      const section = pager.closest('.product-recommendations');
      const carousel = section?.querySelector('[data-related-carousel]');
      const buttons = [...pager.querySelectorAll('[data-related-page]')];
      const previous = section?.querySelector('[data-related-prev]');
      const next = section?.querySelector('[data-related-next]');
      if (!carousel || buttons.length === 0) return;

      function setActive(index) {
        buttons.forEach((button, buttonIndex) => {
          const isActive = buttonIndex === index;
          button.classList.toggle('is-active', isActive);
          if (isActive) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }

      function pageTo(index) {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        const ratio = buttons.length > 1 ? index / (buttons.length - 1) : 0;
        carousel.scrollTo({ left: maxScroll * ratio, behavior: 'smooth' });
        setActive(index);
      }

      let frame = null;
      function syncFromScroll() {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = null;
          const maxScroll = carousel.scrollWidth - carousel.clientWidth;
          if (maxScroll <= 0) {
            setActive(0);
            return;
          }
          const index = Math.round((carousel.scrollLeft / maxScroll) * (buttons.length - 1));
          setActive(Math.max(0, Math.min(buttons.length - 1, index)));
        });
      }

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => pageTo(index));
      });

      function scrollByCard(direction) {
        const card = carousel.querySelector('.product-card');
        const amount = card ? card.getBoundingClientRect().width + 16 : carousel.clientWidth * .8;
        carousel.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      previous?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      carousel.addEventListener('scroll', syncFromScroll, { passive: true });
      setActive(0);
    });
  }

  function initFavorites(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-favorite-button]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      const key = button.dataset.favoriteKey;
      if (!key) return;
      const storageKey = `indartxuFavorite:${key}`;
      const text = button.querySelector('[data-favorite-text]');
      const inactiveLabel = button.dataset.favoriteLabel || text?.textContent || '';
      const activeLabel = button.dataset.favoriteActiveLabel || inactiveLabel;

      const setState = (active) => {
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (text) text.textContent = active ? activeLabel : inactiveLabel;
      };

      let isActive = false;
      try {
        isActive = window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        isActive = false;
      }
      setState(isActive);

      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        isActive = button.getAttribute('aria-pressed') !== 'true';
        setState(isActive);
        try {
          if (isActive) {
            window.localStorage.setItem(storageKey, 'true');
          } else {
            window.localStorage.removeItem(storageKey);
          }
        } catch (error) {
          /* localStorage can be unavailable in privacy modes. */
        }
      });
    });
  }

  function initPurchaseOptions(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-purchase-options]').forEach((options) => {
      if (options.dataset.bound === 'true') return;
      const container = options.closest('.product-form') || options.parentElement;
      const subscription = options.querySelector('[data-purchase-subscription]');
      const frequency = container?.querySelector('[data-purchase-frequency]');
      const frequencyInputs = [...(frequency?.querySelectorAll('[data-purchase-frequency-input]') || [])];
      if (!subscription || !frequency || frequencyInputs.length === 0) return;

      function sync() {
        const isSubscription = subscription.checked;
        frequency.classList.toggle('is-disabled', !isSubscription);
        frequency.setAttribute('aria-disabled', isSubscription ? 'false' : 'true');
        frequencyInputs.forEach((input) => {
          input.disabled = !isSubscription;
        });
      }

      options.dataset.bound = 'true';
      options.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', sync);
      });
      sync();
    });
  }

  function init(root) {
    initGallery(root);
    initVariants(root);
    initRelatedPager(root);
    initPurchaseOptions(root);
    initFavorites(root);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
